import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./index.css";

// Self-hosted Fonts (Poppins 300-700, Inter 400-600)
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";

import DOMPurify from "dompurify";

// Declare Trusted Types for TypeScript if missing
interface TrustedTypesWindow extends Window {
  trustedTypes?: {
    createPolicy: (name: string, options: { createHTML?: (s: string) => string }) => any;
    defaultPolicy?: any;
  };
}

// Fix Trusted Types violation for libraries using innerHTML
const ttWindow = window as unknown as TrustedTypesWindow;
if (ttWindow.trustedTypes && ttWindow.trustedTypes.createPolicy) {
  // 1. Default policy with DOMPurify sanitization
  if (!ttWindow.trustedTypes.defaultPolicy) {
    ttWindow.trustedTypes.createPolicy("default", {
      createHTML: (string: string) => DOMPurify.sanitize(string),
    });
  }

  // 2. Policy for react-helmet-async (required by CSP)
  ttWindow.trustedTypes.createPolicy("react-helmet-async", {
    createHTML: (string: string) => string, // Pass-through for trusted library content
  });

  // 3. Policy for nextjs-helmet (required by CSP)
  ttWindow.trustedTypes.createPolicy("nextjs-helmet", {
    createHTML: (string: string) => string,
  });
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
  